import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-ad83d51e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex flex-col flex-grow shrink-0 justify-between h-full school-side lg:grow-0 bg-gray-50" };
var _hoisted_2 = { class: "overflow-x-hidden relative flex-grow max-h-full" };
import CommonChats from './components/CommonChats.vue';
import CourseChats from './components/CourseChats.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'School',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(CommonChats),
                    _createVNode(CourseChats)
                ])
            ]));
        };
    }
});
